module.exports = __webpack_public_path__ + "01411795bb0f7ce62adea11bc515770b.jpg";